import type {
  AuctionBidListParams,
  AuctionListParams,
  RegistrationListParams,
} from '../api/auctions-api';
import type { QuestionListParams } from '../api/questions-api';
import type { SaleListParams } from '../api/sales-api';

/** Store-scoped keys: switching stores never shares cache. */
export const auctionKeys = {
  all: (storeId: string) => ['stores', storeId, 'auctions'] as const,
  lists: (storeId: string) => [...auctionKeys.all(storeId), 'list'] as const,
  list: (storeId: string, params: AuctionListParams) =>
    [...auctionKeys.lists(storeId), params] as const,
  details: (storeId: string) => [...auctionKeys.all(storeId), 'detail'] as const,
  detail: (storeId: string, id: string) => [...auctionKeys.details(storeId), id] as const,
  bids: (storeId: string, id: string, params: AuctionBidListParams) =>
    [...auctionKeys.detail(storeId, id), 'bids', params] as const,
  allBids: (storeId: string, id: string) => [...auctionKeys.detail(storeId, id), 'bids'] as const,
  offers: (storeId: string, id: string) => [...auctionKeys.detail(storeId, id), 'offers'] as const,
  registrations: (storeId: string) => [...auctionKeys.all(storeId), 'registrations'] as const,
  registrationList: (storeId: string, params: RegistrationListParams) =>
    [...auctionKeys.registrations(storeId), params] as const,
  lotVariants: (storeId: string, storeProductId: string) =>
    [...auctionKeys.all(storeId), 'lot-variants', storeProductId] as const,
  forProduct: (storeId: string, storeProductId: string) =>
    [...auctionKeys.lists(storeId), { storeProductId }] as const,
  looseDrafts: (storeId: string) => [...auctionKeys.lists(storeId), 'loose-drafts'] as const,
  sales: (storeId: string) => [...auctionKeys.all(storeId), 'sales'] as const,
  saleLists: (storeId: string) => [...auctionKeys.sales(storeId), 'list'] as const,
  saleList: (storeId: string, params: SaleListParams) =>
    [...auctionKeys.saleLists(storeId), params] as const,
  sale: (storeId: string, id: string) => [...auctionKeys.sales(storeId), 'detail', id] as const,
  saleLots: (storeId: string, saleId: string) =>
    [...auctionKeys.lists(storeId), { saleId }] as const,
  questions: (storeId: string) => [...auctionKeys.all(storeId), 'questions'] as const,
  questionList: (storeId: string, params: QuestionListParams) =>
    [...auctionKeys.questions(storeId), params] as const,
};
